import * as actions from './portal-mobile-nav.constants';

import { PortalMobileNavType } from './portal-mobile-nav.type';

export const portalShowHideNav = (portalNavShow: PortalMobileNavType) => ({
  type: actions.SHOW_HIDE_MOBILE_NAV,
  portalNavShow: portalNavShow
});
